'use client';

import { useTranslations } from "next-intl";
import Link from "next/link";
import { FaHandHoldingMedical, FaSpa, FaUserDoctor } from "react-icons/fa6";

export default function AboutSection() {
  const t = useTranslations('about_section');

  return (
    <div className="lg:col-span-8 mx-auto max-w-247.5">
      <div className="-mt-16 relative z-10">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 items-center">
          <div className="rounded-xl text-center bg-background p-6 shadow-md ring-1 ring-black/5 max-w-sm mx-auto">
            <div className="mb-3 inline-flex items-center justify-center">
              <FaUserDoctor aria-label="Doctor" className="w-10 h-10 text-contrast" />
            </div>
            <h4 className="text-lg font-semibold leading-tight mb-4">
              <Link href="/services/acupuncture" className="hover:underline">
                {t("acupuncture.title")}
              </Link>
            </h4>
            <p className="mt-2 text-sm">
              {t("acupuncture.description")}
            </p>
          </div>
          <div className="rounded-xl text-center bg-background p-6 shadow-md ring-1 ring-black/5 max-w-sm mx-auto">
            <div className="mb-3 inline-flex items-center justify-center">
              <FaHandHoldingMedical aria-label="Medical care" className="w-10 h-10 text-contrast" />
            </div>
            <h4 className="text-lg font-semibold leading-tight mb-4">
              <Link href="/services/massage" className="hover:underline">
                {t("massage.title")}
              </Link>
            </h4>
            <p className="mt-2 text-sm">
              {t("massage.description")}
            </p>
          </div>
          <div className="rounded-xl text-center bg-background p-6 shadow-md ring-1 ring-black/5 max-w-sm mx-auto">
            <div className="mb-3 inline-flex items-center justify-center">
              <FaSpa aria-label="Spa" className="w-10 h-10 text-contrast" />
            </div>
            <h4 className="text-lg font-semibold leading-tight mb-4">
              <Link href="/services/cosmetology" className="hover:underline">
                {t("cosmetology.title")}
              </Link>
            </h4>
            <p className="mt-2 text-sm">
              {t("cosmetology.description")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
